
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { EnrolledUser, AttendanceRecord } from "@/types/attendance";

export const useEnrolledUsers = (classId: string | undefined, selectedDate: string) => {
  return useQuery<EnrolledUser[], Error>({
    queryKey: ['enrolled-users', classId, selectedDate],
    queryFn: async () => {
      if (!classId) throw new Error("ID de clase no proporcionado");

      // Obtenemos los usuarios inscritos en esta clase específica
      const { data: subscriptions, error: subsError } = await supabase
        .from('class_subscriptions')
        .select(`
          id,
          user_id,
          profiles (
            id,
            username,
            first_name,
            last_name
          )
        `)
        .eq('class_id', classId);

      if (subsError) throw subsError;

      // Luego obtenemos los registros de asistencia para la fecha seleccionada
      const { data: attendance, error: attError } = await supabase
        .from('class_attendance')
        .select('*')
        .eq('class_id', classId)
        .eq('date', selectedDate);

      if (attError) throw attError;

      // Combinamos los datos
      return subscriptions.map((sub: any) => ({
        ...sub,
        attendanceRecord: attendance && attendance.find((att: any) => att.user_id === sub.user_id),
      })) as EnrolledUser[];
    },
    enabled: !!classId,
  });
};
